import { render } from "./partner-property-form.vue?vue&type=template&id=bb7d6f1e&ts=true"
import script from "./partner-property-form.vue?vue&type=script&lang=ts"
export * from "./partner-property-form.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__